import Footer from "../components/Footer";
import Header from "../components/Header";

export default function WIP() {
    
   
  return (
    <div>
     <div
        className="landing"
        style={{ backgroundImage: `url(/img/landing/wip.jpeg)` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-25 z-10"></div>
        <Header />
        <div className="landing_content">
          <h1>We're still working on this. Hang tight!</h1>
          <a href="https://utahdata.org/" style={{ textDecoration: "none", color: "inherit" }}><p>[Explore UTahData.org]</p></a>
        </div>
      </div>
     
       
       
      <Footer/>
    </div>
  )
}

